import React from "react";
import styles from "./index.module.css";
import cancelIcon from "../../../assets/icons/mobileIcons/cancelWhite.png";
import deleteRedIcon from "../../../assets/icons/mobileIcons/deleteOutlinedRed.png";
import { useDispatch, useSelector } from "react-redux";
import {
    closeSectionDeleteModal,
    setDeletingLink,
    setLinksChanged,
    setNonStoreSectionsChanged,
    setSelectedCollection,
    setStoreSectionsChanged
} from "../../../redux/slice/dashboardSlice";
import { message } from "antd";
import { deleteSection, findDiff } from "../../Builder/builderServices/utils";

const index = ({ section }) => {
    const dispatch = useDispatch();
    const { storeSectionsChanged, nonStoreSectionsChanged, deletingLink, selectedHeader } = useSelector((store) => store.root.dashboard);

    const handleCancel = (e) => {
        e.preventDefault();
        dispatch(closeSectionDeleteModal());
        dispatch(setDeletingLink(null));
    };

    const handleDelete = async (e) => {
        e.preventDefault();
        dispatch(closeSectionDeleteModal());
        if (section) {
            await deleteSection(section);
        } else if (deletingLink) {
            let linkCopy;
            let newSection;
            let updatedSections;
            linkCopy = { ...deletingLink, isDeleted: true, sortId: -1 };
            if (selectedHeader === "Collections") {
                newSection = { ...storeSectionsChanged.filter((e) => e.id === deletingLink.parentId)[0] };
                newSection.links = newSection.links.map((e) => (e.id === linkCopy.id ? linkCopy : e));
                updatedSections = storeSectionsChanged.map((e) => (e.id === newSection.id ? newSection : e));
                dispatch(setStoreSectionsChanged(updatedSections));
                dispatch(setSelectedCollection(newSection));
            } else if (selectedHeader === "LinkInBio") {
                newSection = { ...nonStoreSectionsChanged.filter((e) => e.id === deletingLink.parentId)[0] };
                newSection.links = newSection.links.map((e) => (e.id === deletingLink.id ? linkCopy : e));
                updatedSections = nonStoreSectionsChanged.map((e) => (e.id === newSection.id ? newSection : e));
                dispatch(setNonStoreSectionsChanged(updatedSections));
            }
            dispatch(setLinksChanged());
            findDiff();
            dispatch(setDeletingLink(null));
        }
        message.success("Link successfully deleted");
    };
    return (
        <div className={styles.fixedOverlay} onClick={handleCancel}>
            <div
                className={styles.container}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                {section ? (
                    <>
                        <span className={styles.heading}>Delete this section?</span>
                        <span className={styles.desc}>Delete all your links in the '{section?.title}' section? This cannot be undone!</span>
                    </>
                ) : deletingLink ? (
                    <div className={styles.productDetails}>
                        <img className={styles.productImage} src={deletingLink.metaData.response.image} />
                        <div className={styles.messageContainer}>
                            <span className={styles.heading}>Delete forever!</span>
                            <span className={styles.desc}>Are you sure you want to delete this item?</span>
                        </div>
                    </div>
                ) : (
                    <></>
                )}
                <div className={styles.buttonsContainer}>
                    <div className={styles.cancelButton} onClick={handleCancel}>
                        <img src={cancelIcon} />
                        <span>Cancel</span>
                    </div>
                    <div className={styles.deleteButton} onClick={handleDelete}>
                        <img src={deleteRedIcon} />
                        <span>Delete</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default index;
